// regex to check if string starts with 0047 or +47
const NORWEGIAN_PHONE_PREFIX = /^(0047|\+47)/

export const removeAllSpaces = (str: string) => str.replace(/\s/g, '')

// Removes prefix to check phonenumber easier
export const nonPrefixedPhoneNumber = (num: string) => {
  const hasPrefix = num.match(NORWEGIAN_PHONE_PREFIX)
  return hasPrefix ? num.replace(NORWEGIAN_PHONE_PREFIX, '') : num
}

export const checkIfDuplicatePhonenumber = (first: string, second: string) => {
  const firstWithoutPrefix = nonPrefixedPhoneNumber(first)
  const secondWithoutPrefix = nonPrefixedPhoneNumber(second)

  return firstWithoutPrefix === secondWithoutPrefix
}
